import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "./ButtonNew";
import CustomizedDialogs from "./Dialog";
import { IconProps } from "./Icon";

type ComponentActionButtonBaseProps = {
  action?: () => void;
  actionIsDisabled?: boolean | undefined;
  actionText?: null | string | undefined;
  iconName?: IconProps["iconName"] | undefined;
};

const ComponentActionButtonBase = ({
  action,
  actionIsDisabled,
  actionText,
  iconName,
}: ComponentActionButtonBaseProps) => {
  return (
    <Button disabled={actionIsDisabled} onClick={action} size="sm" startIconName={iconName} variant="tertiary">
      <p className="sentence-case ml-1.5 font-ds-body-semibold-sm">{actionText}</p>
    </Button>
  );
};

export const ComponentDownloadActionButton = (props: Omit<ComponentActionButtonBaseProps, "iconName">) => {
  const { t } = useTranslation();
  return (
    <ComponentActionButtonBase {...props} actionText={props?.actionText ?? t("general.download")} iconName="Download" />
  );
};

export const ComponentUploadActionButton = (props: Omit<ComponentActionButtonBaseProps, "iconName">) => {
  const { t } = useTranslation();
  return (
    <ComponentActionButtonBase {...props} actionText={props.actionText ?? t("general.upload")} iconName="Upload" />
  );
};

export const ComponentUploadActionButtonWithModal = (props: {
  fileMetaDataAPI?: {
    getFileMetaDataBody: (file: File) => any;
    url: string;
  };
  formDataFileKeyName: string;
  headerText?: string;
  headerTitle?: string;
  onSuccess?: (response: any) => void;
  onUploadClick?: () => void;
  queryParams: ((fileMetaData: any) => { name: string; value: string }[]) | { name: string; value: string }[];
  renderModalBody: () => React.ReactNode;
  successMessage?: string;
  url: string;
}) => {
  const Component = <ComponentUploadActionButton action={props.onUploadClick} />;
  return <CustomizedDialogs Component={Component} {...(props as any)} onUploadDone={undefined} />;
};
